export default __webpack_public_path__ + "fonts/react_logo.ab043b70896227d7d9f960fa24a0ab2d.png";